import api from './api';

const mediaService = {
  async getAll(projectId, eventId, page = 1, limit = 10) {
    const params = { page, limit };
    if (projectId) params.projectId = projectId;
    if (eventId) params.eventId = eventId;
    const response = await api.get('/media-gallery', { params });
    return response.data;
  },

  async getOne(id) {
    const response = await api.get(`/media-gallery/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/media-gallery', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.patch(`/media-gallery/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/media-gallery/${id}`);
    return response.data;
  },
};

export default mediaService;
